import {
  BaseQueryFn,
  createApi,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { authFetch } from '../client/domain/AuthFetch';
import { OptionalExtraArguments } from '../client/configureStore';
import { CardResponseMeta } from '@yleisradio/areena-types';
import { getClientYleApiCredentials } from '../client/utils/authKeys';

type CustomBaseQueryType = BaseQueryFn<
  {
    url: string;
    requestInit?: RequestInit;
  },
  unknown,
  FetchBaseQueryError,
  OptionalExtraArguments,
  CardResponseMeta
>;

const customBaseQuery =
  (): CustomBaseQueryType =>
  async ({ url, requestInit }) => {
    const yleApiCredentials = getClientYleApiCredentials();

    try {
      const response = await authFetch(
        { credentials: 'include' },
        yleApiCredentials
      )(url, requestInit);

      if (!response.ok) {
        return {
          error: {
            status: response.status,
            data: response.statusText,
          },
        };
      }

      const result = await response.json();

      return { data: result.data, meta: result.meta };
    } catch (error) {
      if (error instanceof SyntaxError) {
        return {
          error: {
            status: 'PARSING_ERROR',
            originalStatus: 0,
            data: error.message,
            error: error.name,
          },
        };
      }

      return {
        error: {
          status: 'CUSTOM_ERROR',
          data: error,
          error: 'error',
        },
      };
    }
  };

const rootApi = createApi({
  baseQuery: customBaseQuery(),
  tagTypes: ['Media', 'Favorite'],
  reducerPath: 'rootApi',
  endpoints: () => ({}),
});

export { rootApi };
